<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <vxe-grid
      ref="table"
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="orderCode"
      :checkboxConfig="{
        reserve: true,
        highlight: false,
      }"
    >
      >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip class="item" effect="dark" content="查看" placement="top">
          <i class="el-icon-view tool-btn" @click="viewDetail(row)"></i>
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from '../table-city/table-columns'
export default {
  components: {},
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      selectList: [],
      fullScreenLoading: false,
    }
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 204
    },
    viewDetail(row) {
      console.log(row.custCode)
    },
    batchDispatch() {
      console.log('batchDispatch')
    },
    batchOneKeyDispatch() {
      console.log('batchOneKeyDispatch')
    },
    batchTransfer() {
      console.log('batchTransfer')
    },
  },
}
</script>
